/* eslint-disable no-unused-expressions */
import React, { forwardRef } from "react";
import { IMaskInputProps } from "react-imask";
import { FacTextFieldProps } from "../FacTextField.type";
import { FacTextField } from "../FacTextField.component";
import MaskedTextField from "./MaskedTextField.component";

export const withMaskedTextField = (
    defaultProps: FacTextFieldProps,
    maskProps: IMaskInputProps<HTMLInputElement>,
) => (
    // eslint-disable-next-line react/display-name
    forwardRef<HTMLDivElement, FacTextFieldProps>(
        ({ onChange, InputProps, InputLabelProps, ...props }, ref) => (
            <FacTextField
                ref={ref}
                onChange={onChange}
                {...defaultProps}
                {...props}
                InputProps={{
                    ...InputProps,
                    value: props.value,
                    inputComponent: MaskedTextField,
                    inputProps: {
                        onAccept: onChange ? (value: string) => onChange({ target: { name: props.name || "", value } } as unknown as React.ChangeEvent<HTMLInputElement>) : undefined,
                        ...maskProps,
                    },
                }}
                InputLabelProps={{
                    shrink: true,
                    ...InputLabelProps
                }}
            />
        ),
    )
);

export default withMaskedTextField;
